// src/components/pages/allocation/partial/PerformanceTable.js
import React, { useState } from "react";
import styles from "./style/BacktestResult.module.css"; 
import { useTranslation } from "react-i18next"; // react-i18next 훅 임포트

function PerformanceTable({ equalMetrics, optimizedMetrics, benchmarkMetrics, benchmarkSymbol }) {
  const [tooltip, setTooltip] = useState(null);
  const { t} = useTranslation(); // useTranslation 호출 추가
  
  const explanations = {
    sharpe: t("sharpePerformancetable"),
    calmar: t("calmarPerformancetable"),
    sortino: t("sortinoPerformancetable"),
  };
  

  const handleTooltip = (metric) => {
    setTooltip(tooltip === metric ? null : metric);
  };

  return (
    // className을 styles.클래스이름 으로 변경
    <div className={styles['performance-table-container']}>
      <table className={styles['performance-table']}>
      <thead>
          <tr>
          <th>{t("indicator")}</th>
          <th>{t("equalAllocation")}</th>
          <th>{t("optimizedPortfolio")}</th>
          {/* <th>{t("benchmark", { benchmarkSymbol })}</th> */}
          </tr>
      </thead>
      <tbody>
          <tr>
          <td><strong>{t("cumulativeReturn")}</strong></td>
          {/* 하이픈이 없는 클래스는 styles.highlight 로 접근 가능 */}
          <td className={styles.highlight}>{(equalMetrics.cumulativeReturn * 100).toFixed(2)}%</td>
          <td className={styles.highlight}>{(optimizedMetrics.cumulativeReturn * 100).toFixed(2)}%</td>
          {/* <td className={styles.highlight}>{(benchmarkMetrics.cumulativeReturn * 100).toFixed(2)}%</td> */}
          </tr>
          {/* 💡 [추가된 부분] CAGR (연평균 성장률) 행 */}
          <tr>
            <td><strong>{t("cagr")}</strong></td>
            <td className={styles.highlight}>{(equalMetrics.cagr * 100).toFixed(2)}%</td>
            <td className={styles.highlight}>{(optimizedMetrics.cagr * 100).toFixed(2)}%</td>
          </tr>
          {/* 💡 [여기까지] */}
          <tr>
          <td><strong>{t("annualVolatility")}</strong></td>
          <td>{(equalMetrics.volatility * 100).toFixed(2)}%</td>
          <td>{(optimizedMetrics.volatility * 100).toFixed(2)}%</td>
          {/* <td>{(benchmarkMetrics.volatility * 100).toFixed(2)}%</td> */}
          </tr>
          <tr>
          <td><strong>{t("maxDrawdown")}</strong></td>
          <td>{(equalMetrics.maxDrawdown * 100).toFixed(2)}%</td>
          <td>{(optimizedMetrics.maxDrawdown * 100).toFixed(2)}%</td>
          {/* <td>{(benchmarkMetrics.maxDrawdown * 100).toFixed(2)}%</td> */}
          </tr>
          <tr>
          <td>
              <strong 
                onClick={() => handleTooltip("sharpe")}
                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
              >
                {t("sharpeRatio")}
              </strong>
              {/* tooltip-box는 하이픈이 있으므로 styles['tooltip-box']로 접근 */}
              {tooltip === "sharpe" && <div className={styles['tooltip-box']}>{explanations.sharpe}</div>}
            </td>
          <td>{equalMetrics.sharpeRatio.toFixed(2)}</td>
          <td>{optimizedMetrics.sharpeRatio.toFixed(2)}</td>
          {/* <td>{benchmarkMetrics.sharpeRatio.toFixed(2)}</td> */}
          </tr>
          <tr>
          <td>
              <strong 
                onClick={() => handleTooltip("calmar")}
                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
              >
                {t("calmarRatio")}
              </strong>
              {tooltip === "calmar" && <div className={styles['tooltip-box']}>{explanations.calmar}</div>}
            </td>
          <td>{equalMetrics.calmarRatio.toFixed(2)}</td>
          <td>{optimizedMetrics.calmarRatio.toFixed(2)}</td>
          {/* <td>{benchmarkMetrics.calmarRatio.toFixed(2)}</td> */}
          </tr>
          <tr>
          <td>
              <strong 
                onClick={() => handleTooltip("sortino")}
                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
              >
                {t("sortinoRatio")}
              </strong>
              {tooltip === "sortino" && <div className={styles['tooltip-box']}>{explanations.sortino}</div>}
            </td>
          <td>{equalMetrics.sortinoRatio.toFixed(2)}</td>
          <td>{optimizedMetrics.sortinoRatio.toFixed(2)}</td>
          {/* <td>{benchmarkMetrics.sortinoRatio.toFixed(2)}</td> */}
          </tr>
      </tbody>
      </table>
     
    </div>
  );
}

export default PerformanceTable;